import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';
import axios from 'axios';
// API URLs
import { config } from '../config';
const base_url = config.base_url;
const vuexPersist = new VuexPersistence({
  key: 'gdqassoc',
  storage: window.localStorage,
});
// Ensure axios has token on app start
const persistedToken = localStorage.getItem('gdq_atoken');
if (persistedToken) {
  axios.defaults.headers.common['Authorization'] = persistedToken;
}

export default createStore({
  //======
  // STATE
  //======
  state: {
    // Blur all e-mail adresses and names
    anon: false,
    usergroups: [],
    //-----------------
    // User and Profile
    //-----------------
    status: '',
    token: localStorage.getItem('gdq_atoken') || '',
    breadcrumbs: [],
    user_id: gdq_getuserid(localStorage.getItem('gdq_atoken') || ''),
    user: {
      first_name: '',
      family_name: '',
      email: '',
    },
    profile: {
      company_name: '',
      address_1: '',
      address_2: '',
      zip_code: '',
      city: '',
      country_id: 0,
      consultantstatus_id: 0,
      certified_by: 0,
      company_id: 0,
      partner_id: 0,
      aggregated_reports: 0,
    },
    routeafterlogin: '',
    //------------
    // Consultants
    //------------
    currentconsultant_id: 0,
    consultants: [],
    consultantchanged: 0,
    consultantlabelchanged: 0,
    //----------
    // Companies
    //----------
    currentcompany_id: 0,
    companies: [],
    companychanged: 0,
    companylabelchanged: 0,
    //---------
    // Partners
    //---------
    currentpartner_id: 0,
    partners: [],
    partnerchanged: 0,
    partnerlabelchanged: 0,
    //----------
    // Tutorials
    //----------
    currenttutorial_id: 0,
    tutorials: [],
    tutorialchanged: 0,
    //----------
    // Materials
    //----------
    currentmaterial_id: 0,
    materials: [],
    materialchanged: 0,
    //---------------------
    // e-Learning Materials
    //---------------------
    currentelearningmaterial_id: 0,
    elearningmaterials: [],
    elearningmaterialchanged: 0,    
    //-------
    // Videos
    //-------
    currentvideo_id: 0,
    videos: [],
    videochanged: 0,
    //----------
    // Countries
    //----------
    countries: [],
  },
  //==========
  // MUTATIONS
  //==========
  mutations: {
    toggleanon(state) {
      state.anon = !state.anon;
    },
    // User Group
    usergroups_set(state, payload) {
      state.usergroups = payload;
    },
    //-------------
    // Login/logout
    //-------------
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.user_id = payload.user_id
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user_id = 0
      state.user = [];
      state.profile = [];
    },
    setrouteafterlogin(state, payload) {
      state.routeafterlogin = payload;
    },
    //--------------------------
    // Profile and user handling
    //--------------------------
    profile_set(state, profile) {
      state.profile = profile;
    },
    user_set(state, user) {
      state.user = user;
    },
    //-----------
    // Consultant
    //-----------
    consultant_setcurrent(state, consultant_id) {
      state.currentconsultant_id = consultant_id;
    },
    consultantchanged_set(state, consultant_id) {
      state.consultantchanged = consultant_id;
    },
    consultantlabelchanged_set(state, consultant_id) {
      state.consultantlabelchanged = consultant_id;
    },
    //--------
    // Company
    //--------
    company_setcurrent(state, company_id) {
      state.currentcompany_id = company_id;
    },
    companychanged_set(state, company_id) {
      state.companychanged = company_id;
    },
    companylabelchanged_set(state, company_id) {
      state.companylabelchanged = company_id;
    },
    //--------
    // Partner
    //--------
    partner_setcurrent(state, partner_id) {
      state.currentpartner_id = partner_id;
    },
    partnerchanged_set(state, partner_id) {
      state.partnerchanged = partner_id;
    },
    partnerlabelchanged_set(state, partner_id) {
      state.partnerlabelchanged = partner_id;
    },
    //----------
    // Tutorials
    //----------
    tutorial_setcurrent(state, tutorial_id) {
      state.currenttutorial_id = tutorial_id;
    },
    tutorialchanged_set(state, tutorial_id) {
      state.tutorialchanged = tutorial_id;
    },
    //----------
    // Materials
    //----------
    material_setcurrent(state, material_id) {
      state.currentmaterial_id = material_id;
    },
    materialchanged_set(state, material_id) {
      state.materialchanged = material_id;
    },
    //---------------------
    // e-Learning Materials
    //---------------------
    elearningmaterial_setcurrent(state, material_id) {
      state.currentelearningmaterial_id = material_id;
    },
    elearningmaterialchanged_set(state, material_id) {
      state.elearningmaterialchanged = material_id;
    },
    //-------
    // Videos
    //-------
    video_setcurrent(state, video_id) {
      state.currentvideo_id = video_id;
    },
    videochanged_set(state, video_id) {
      state.videochanged = video_id;
    },
    //----------
    // Countries
    //----------
    countries_set(state, countries) {
      state.countries = countries.result;
    },
  },
  //========
  // ACTIONS
  //========
  actions: {
    toggleanon({commit}) {
      commit('toggleanon')
    },
    profile_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/g_profile/' + payload.id)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    user_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/i_user/' + payload.id)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    setrouteafterlogin({ commit }, payload) {
      commit('setrouteafterlogin', payload)
    },
    // General CRUD - see if this works
    record_read(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/' + payload.table_name + '/' + payload.id)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    records_readall(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/' + payload.table_name)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    records_readlist(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        var url = base_url + '/' + payload.table_name + '/list';
        var sep = '?';
        if (payload.filter) {
          url += sep + 'filter=' + JSON.stringify(payload.filter);
          sep = '&';
        }
        if (payload.filtersep) {
          url += sep + 'filtersep=' + payload.filtersep;
          sep = '&';
        }
        if (payload.orderby) {
          url += sep + 'orderby=' + payload.orderby;
          sep = '&';
          if (payload.order) {
            url += sep + 'order=' + payload.order;
            sep = '&';
          }
        }
        if (payload.limit) {
          url += sep + 'limit=' + payload.limit;
          sep = '&';
        }
        if (payload.start) {
          url += sep + 'start=' + payload.start;
          sep = '&';
        }
        axios.get(url)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    records_exportexcel(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/excelexport',
          method: 'POST',
          responseType: 'blob',
          data: payload,
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    record_put(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve) => {
        axios.put(
          base_url + "/" + payload.table_name + "/" + payload.id,
          JSON.stringify(payload.record), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then((resp) => {
            resolve(resp);
          })
      });
    },
    record_post(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve) => {
        axios.post(
          base_url + '/' + payload.table_name,
          JSON.stringify(payload.record), {
          headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
          }
        }
        )
          .then(resp => {
            resolve(resp);
          });
      });
    },
    record_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.delete(base_url + '/' + payload.table_name + '/' + payload.id)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    image_save(_, payload) {
      const url = base_url + '/image';
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          url,
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    async image_get(_, payload) {
      const url = base_url + '/' + payload.table_name + '/image/' + payload.field_name + '/' + payload.id;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      const config = { url: url, method: "get", responseType: "blob" }
      const response = await axios.request(config)
      return response.data // the blob
    },
    // User and login stuff
    forgotpassword(_, payload) {
      var filter = payload.filter
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/forgotpassword?filter=' + JSON.stringify(filter) + '&a=1')
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    userbytoken_fetch(_, payload) {
      var token = payload.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/userbytoken?t=' + token)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    resetpassword_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      axios.put(
        base_url + '/resetpassword_save/' + payload.user.id,
        JSON.stringify(payload.user), {
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        }
      }
      )
    },
    //-------------
    // Mail servers
    //-------------
    mailservers_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_mailservers",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    mailserver_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_mailservers/" + payload.id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },

    //-----------------
    // Admin mail texts
    //-----------------
    adminmailtext_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_adminmailtexts?filter=" + JSON.stringify(filter),
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    adminmailtext_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/g_adminmailtexts",
          JSON.stringify(payload.adminmailtext), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //------------------
    // Default Mail Text
    //------------------
    defaultmailtext_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_defaultmailtexts?filter=" + JSON.stringify(filter),
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    defaultgdqshortmailtext_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_gdqshortdefaultmailtexts?filter=" + JSON.stringify(filter),
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    defaultoscmailtext_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_oscdefaultmailtexts?filter=" + JSON.stringify(filter),
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    //----------
    // Languages
    //----------
    languages_fetch() {
      var filter = {
        language_enabled: {
          operator: '=',
          value: 1,
        }
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_languages?filter=" + JSON.stringify(filter) + "&orderby=language_name&start=0&limit=999999",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    //----------------
    // Payment methods
    //----------------
    paymentmethods_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_paymentmethods",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    //---------------
    // System Screens
    //---------------
    systemscreens_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_systemscreens?orderby=screen_name",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    systemscreenelements_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url
          + '/g_systemscreenelements?'
          + 'filter=' + JSON.stringify(filter)
          + '&orderby=element_name'
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    systemscreenelement_fetch(_, payload) {
      var id = payload.id;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url
          + '/g_systemscreenelements/' + id
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    systemscreenelement_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.put(
          base_url + "/g_systemscreenelements/" + payload.record.id,
          JSON.stringify(payload.record), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then((resp) => {
            resolve(resp);
          })
      })
    },
    //------------
    // User Groups
    //------------
    usergroups_fetch({ commit }) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/i_usergrp",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            commit('usergroups_set', resp.data.result);
            resolve(resp)
          })
      })
    },
    //-----------------
    // Login and logout
    //-----------------
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
          url: base_url + '/login',
          data: user,
          method: 'POST'
        })
          .then(resp => {
            const token = resp.data.token;
            // Fix this later
            // const user = resp.data.token;
            var payload = token.split('.');
            payload = payload[1];
            payload = atob(payload);
            payload = JSON.parse(payload);
            var user_id = payload.id;
            localStorage.setItem('gdq_atoken', token)
            // Add the following line:
            axios.defaults.headers.common['Authorization'] = 'Bearer:' + token
            commit('auth_success', { "token": token, "user_id": user_id })
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('gdq_atoken')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('gdq_atoken')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    switchto(_, user) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios({
          url: base_url + '/login',
          data: user,
          method: 'POST'
        })
          .then(resp => {
            const token = resp.data.token;
            resolve(token);
          })
      });
    },
    //-----
    // User
    //-----
    users_upload(_, payload) {
      //---------------------------------------------------
      // Payload is a formdata object with the field "file"
      // for the file to upload
      //---------------------------------------------------
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_users_upload",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    user_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/i_user",
          JSON.stringify(payload.i_user), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    profile_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_profile_create",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    profile_generate_certificate_number(_, payload) {
      const id = payload.id;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.put(
          base_url + "/gdq_certificatenumber/" + id,
          {},
          {
            headers: {
              "Accept": "application/json",
              "Content-type": "application/json",
            }
          }
        )
          .then((resp) => {
            resolve(resp);
          })
      })
    },
    profile_send_welcome_email(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/gdq_sendwelcomemail/" + payload.user_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    //----------------------
    // Check if email exists
    //----------------------
    user_email_check(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/i_user?"
          + 'filter=' + JSON.stringify(filter),
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    //-----------------------------------------------
    // Save a field to a table with an id and a value
    //-----------------------------------------------
    field_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.put(
          base_url + "/" + payload.tablename + "/" + payload.record.id,
          JSON.stringify(payload.record), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then((resp) => {
            resolve(resp);
          })
      })
    },
    //---------------------
    // Save a syspref field
    //---------------------
    syspref_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_sys_pref",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //---------------------
    // Read a syspref field
    //---------------------
    syspref_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/gdq_sys_pref_get/" + payload.key,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    //-------
    // Labels
    //-------
    labels_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_labels?orderby=label",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    enterprises_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + '/g_enterprises/list',
          '', {
          headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json',
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    //-----
    // ToTs
    //-----
    tots_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(
          base_url + "/gdq_tots_get",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })

    },
    //------------
    // Consultants
    //------------
    consultantusergroups_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(
          base_url + "/gdq_consultantusergroups_get/" + payload.consultant_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultantusergroups_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_consultantusergroups_save",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultantchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('consultantchanged_set', payload.consultant_id);
        resolve(true);
      })
    },
    consultantlabelchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('consultantlabelchanged_set', payload.consultant_id);
        resolve(true);
      })
    },
    consultant_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('consultant_setcurrent', payload.consultant_id);
        resolve(true);
      })
    },
    consultantlabel_add(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_consultantlabel_save",
          JSON.stringify(payload.label), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultantlabel_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/gdq_consultantlabel_delete/" + payload.id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    consultantlabels_bulkadd(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_consultantlabels_save",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultants_exportexcel(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + "/gdq_consultants_export_excel",
          method: 'POST',
          responseType: 'blob',
          data: payload,
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultant_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/gdq_consultant_get/" + payload.consultant_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    //-------------------------
    // All Consultant's Surveys
    //-------------------------
    consultantsurveys_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url
          + '/gdq_surveys_get?'
          + 'filter=' + JSON.stringify(filter)
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // All consultant's surveys in admin interface
    admin_consultantsurveys_fetch(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url
          + '/gdq_admin_consultantsurveys_get/' + payload.user_id
          + '?filter=' + JSON.stringify(filter)
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    gdq_addonsurvey_exportexcel(_,payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_addonsurvey_exportexcel',
          method: 'POST',
          responseType: 'blob',
          data: payload,
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    //------------------------------
    // Set delete flag on consultant
    //------------------------------
    consultant_flagdelete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_consultant_flagdelete",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //------------------------------------------
    // List of consultants with filtering option
    //------------------------------------------
    consultants_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      var label_id = payload.label_id
      var usergroup_id = payload.usergroup_id
      var consultantstatus_id = payload.consultantstatus_id
      var consultantgroup_id = payload.consultantgroup_id ? payload.consultantgroup_id : 0
      var deleted = payload.deleted
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      // Construct the query string
      let queryString = 'filter=' + encodeURIComponent(JSON.stringify(filter))
      + '&start=' + start
      + '&limit=' + limit
      + '&orderby=' + orderby
      + '&order=' + order
      + '&label_id=' + label_id
      + '&usergroup_id=' + usergroup_id
      + '&consultantstatus_id=' + consultantstatus_id
      + '&consultantgroup_id=' + consultantgroup_id
      + '&deleted=' + deleted
      + '&enterprise_id=' + (payload.enterprise_id || 0);
    
      // Conditionally add the newsletter parameter if it exists in the payload
      if (payload.newsletter !== undefined) {
        queryString += '&newsletter=' + payload.newsletter;
      }
      
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/gdq_consultants_get?' + queryString
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultantlabels_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(
          base_url + "/gdq_consultantlabels_get/" + payload.consultant_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    consultantgroups_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/g_groups?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //------------
    // Surveytypes
    //------------
    surveytypes_fetch() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_surveytypes",
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      });
    },
    //----------
    // Companies
    //----------
    company_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/g_companies",
          JSON.stringify(payload.company), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    companychanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('companychanged_set', payload.company_id);
        resolve(true);
      })
    },
    companylabelchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('companylabelchanged_set', payload.company_id);
        resolve(true);
      })
    },
    company_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('company_setcurrent', payload.company_id);
        resolve(true);
      })
    },
    companylabel_add(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_companylabel_save",
          JSON.stringify(payload.label), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
            //          return dispatch('group_fetch');
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    companylabel_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/gdq_companylabel_delete/" + payload.id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    company_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/gdq_company_get/" + payload.company_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    companies_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      var label_id = payload.label_id ? payload.label_id : 0
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/gdq_companies_get?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
          + '&label_id=' + label_id
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    companylabels_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(
          base_url + "/gdq_companylabels_get/" + payload.company_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //---------
    // Partners
    //---------
    partner_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/g_partners",
          JSON.stringify(payload.partner), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    partnerchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('partnerchanged_set', payload.partner_id);
        resolve(true);
      })
    },
    partnerlabelchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('partnerlabelchanged_set', payload.partner_id);
        resolve(true);
      })
    },
    partner_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('partner_setcurrent', payload.partner_id);
        resolve(true);
      })
    },
    partnerlabel_add(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_partnerlabel_save",
          JSON.stringify(payload.label), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
            //          return dispatch('group_fetch');
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    partnerlabel_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/gdq_partnerlabel_delete/" + payload.id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    partner_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/gdq_partner_get/" + payload.partner_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    partners_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      var label_id = payload.label_id ? payload.label_id : 0
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/gdq_partners_get?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
          + '&label_id=' + label_id
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    partnerlabels_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(
          base_url + "/gdq_partnerlabels_get/" + payload.partner_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //----------
    // Tutorials
    //----------
    tutorial_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/g_tutorials",
          JSON.stringify(payload.tutorial), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    tutorialchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('tutorialchanged_set', payload.tutorial_id);
        resolve(true);
      })
    },
    tutorial_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('tutorial_setcurrent', payload.tutorial_id);
        resolve(true);
      })
    },
    tutorial_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/g_tutorials/" + payload.tutorial_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    tutorial_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_tutorials/" + payload.tutorial_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    tutorials_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/g_tutorials?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    //----------
    // Materials
    //----------
    materialfile_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_materialfile_save",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    material_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_material_create",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    materialchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('materialchanged_set', payload.material_id);
        resolve(true);
      })
    },
    material_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('material_setcurrent', payload.material_id);
        resolve(true);
      })
    },
    material_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/g_materials/" + payload.material_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    material_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_materials/" + payload.material_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    materials_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/g_materials?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    //---------------------
    // e-Learning Materials
    //---------------------
    elearningmaterialfile_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_elearningmaterialfile_save",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    elearningmaterial_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_elearningmaterial_create",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    elearningmaterialchanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('elearningmaterialchanged_set', payload.material_id);
        resolve(true);
      })
    },
    elearningmaterial_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('elearningmaterial_setcurrent', payload.material_id);
        resolve(true);
      })
    },
    elearningmaterial_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/g_elearning_materials/" + payload.material_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    elearningmaterial_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_elearning_materials/" + payload.material_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    elearningmaterials_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/g_elearning_materials?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    elearningcoursebookings_fetch(_,payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/gdq_el_course_get_consultants/'+payload.course_id
        )
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })      
    },
    elearningcoursebookings_add(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_el_course_addconsultant",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err)
        })
      })      
    },
    elearningcoursebookings_remove(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.post(
          base_url + "/gdq_el_course_removeconsultant",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
        .then(resp => {
          resolve(resp)
        })
      }
      )
    },

    //-------
    // Videos
    //-------
    videofile_save(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_videofile_save",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    video_create(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_video_create",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    videochanged_set({ commit }, payload) {
      return new Promise((resolve) => {
        commit('videochanged_set', payload.video_id);
        resolve(true);
      })
    },
    video_setcurrent({ commit }, payload) {
      return new Promise((resolve) => {
        commit('video_setcurrent', payload.video_id);
        resolve(true);
      })
    },
    video_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.delete(
          base_url + "/g_videos/" + payload.video_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    video_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.get(
          base_url + "/g_videos/" + payload.video_id,
          '', {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
      })
    },
    videos_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/g_videos?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    //----------
    // Countries
    //----------
    countries_fetch({ commit }) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/g_countries')
          .then(resp => {
            commit('countries_set', resp.data);
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //--------------------
    // Consultant Statuses
    //--------------------
    consultantstatuses_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/g_consultantstatus?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //---------
    // Invoices
    //---------
    invoices_fetch(_, payload) {
      var filter = payload.filter;
      var start = payload.start;
      var limit = payload.limit;
      var orderby = payload.orderby
      var order = payload.order;
      var company_id = payload.company_id;
      var partner_id = payload.partner_id;
      var surveytype_id = payload.surveytype_id;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token;
      return new Promise((resolve, reject) => {
        axios.get(base_url +
          '/gdq_invoices_get?'
          + 'filter=' + JSON.stringify(filter)
          + '&start=' + start
          + '&limit=' + limit
          + '&orderby=' + orderby
          + '&order=' + order
          + '&company_id=' + company_id
          + '&partner_id=' + partner_id
          + '&surveytype_id=' + surveytype_id
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    invoices_exportexcel(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + "/gdq_invoices_export_excel",
          method: 'POST',
          responseType: 'blob',
          data: JSON.stringify(payload),
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    //-----
    // GDPR
    //-----
    gdpr_fetch(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_gdpr_search",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    gdpr_delete(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_gdpr_delete",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    anonymize_candidates_fetch(_, payload) {
      const start = (payload && payload.start) ? payload.start : 1;
      const limit = (payload && payload.limit) ? payload.limit : 10;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + "/gdq_anonymize_candidates?start=" + start + "&limit=" + limit)
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    anonymize_group(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdq_gdpr_anonymize_group",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    legacyconsultant_search(_, payload) {
      var filter = payload.filter;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/gdql_legacyconsultant_search?filter=' + JSON.stringify(filter))
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    legacyconsultant_get(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.get(base_url + '/gdql_legacyconsultant_get/' + payload.id)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    legacyconsultant_import(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdql_legacyconsultant_import",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    legacysurvey_import(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve, reject) => {
        axios.post(
          base_url + "/gdql_legacysurvey_import",
          payload, {
          headers: {
            "Accept": "application/json",
            "Content-type": "multipart/form-data",
          }
        }
        )
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    bulkmail_send(_, payload) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios.post(
          base_url + "/gdq_api_sendbulkmail",
          JSON.stringify(payload), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
        )
        .then(resp => {
          resolve(resp);
        })
      })
    }
  },

  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => state.user,
    profile: state => state.profile,
    user_id: state => state.user_id,
    token: state => state.token,
    currentgroup_id: state => state.currentgroup_id,
    currentgroup: state => state.currentgroup
  },
  plugins: [vuexPersist.plugin]
})
//-----------------
// Helper functions
//-----------------
function gdq_getuserid(token) {
  if (!token) return 0;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));
    return decoded.id || 0;
  } catch (e) {
    return 0;
  }
}
